export enum PermissionType {
  Analytics = 1,
  Assessments = 2,
  LearningManagement = 4,
  Administration = 8,
  Courses = 16,
  RoleSkillManagement = 32,
}
